import {
  FaChartBar,
  FaPalette,
  FaCog,
  FaFileInvoiceDollar,
  FaCreditCard,
  FaMoneyBillWave,
  FaShoppingCart,
  FaUsers,
  FaUserShield,
  FaFolder,
  FaFileAlt,
  FaFile,
  FaLanguage,
  FaAd,
  FaServer,
  FaFileAlt as FaLogs,
  FaBook,
  FaNewspaper,
  FaLifeRing,
  FaBullhorn,
  FaEnvelope,
} from 'react-icons/fa';
import {ComponentType} from 'react';

// Изменено: 2026-01-09 - Создан статичный конфиг меню админки
// Описание: Меню админки теперь хранится в коде, а не в БД
// Все пункты меню жестко заданы программистом

export interface AdminMenuItem {
  label: string;
  action: string;
  icon: ComponentType<{className?: string; size?: string | number}>;
  permissions?: string[];
}

export const adminMenuItems: AdminMenuItem[] = [
  {
    label: 'Analytics',
    action: '/admin',
    icon: FaChartBar,
    permissions: ['admin.access'],
  },
  {
    label: 'Appearance',
    action: '/admin/appearance',
    icon: FaPalette,
    permissions: ['appearance.update'],
  },
  {
    label: 'Settings',
    action: '/admin/settings',
    icon: FaCog,
    permissions: ['settings.update'],
  },
  {
    label: 'Plans',
    action: '/admin/plans',
    icon: FaFileInvoiceDollar,
    permissions: ['plans.update'],
  },
  {
    label: 'Add-ons',
    action: '/admin/addons',
    icon: FaShoppingCart,
    permissions: ['plans.update'],
  },
  {
    label: 'Subscriptions',
    action: '/admin/subscriptions',
    icon: FaCreditCard,
    permissions: ['subscriptions.update'],
  },
  {
    label: 'Payments',
    action: '/admin/payments',
    icon: FaMoneyBillWave,
    permissions: ['subscriptions.update'],
  },
  {
    label: 'Orders',
    action: '/admin/orders',
    icon: FaShoppingCart,
    permissions: ['subscriptions.update'],
  },
  {
    label: 'Mailings',
    action: '/admin/mailings',
    icon: FaEnvelope,
    permissions: ['subscriptions.update'],
  },
  {
    label: 'Users',
    action: '/admin/users',
    icon: FaUsers,
    permissions: ['users.update'],
  },
  {
    label: 'Roles',
    action: '/admin/roles',
    icon: FaUserShield,
    permissions: ['roles.update'],
  },
  {
    label: 'Projects',
    action: '/admin/projects',
    icon: FaFolder,
  },
  {
    label: 'Templates',
    action: '/admin/templates',
    icon: FaFileAlt,
  },
  {
    label: 'Branded Domains',
    action: '/admin/custom-domains',
    icon: FaFile,
  },
  {
    label: 'Pages',
    action: '/admin/custom-pages',
    icon: FaFileAlt,
    permissions: ['custom_pages.update'],
  },
  {
    label: 'Documentation',
    action: '/admin/docs',
    icon: FaBook,
    permissions: ['settings.update'],
  },
  {
    label: 'Blog',
    action: '/admin/blog',
    icon: FaNewspaper,
    permissions: ['blog.manage'],
  },
  {
    label: 'Files',
    action: '/admin/files',
    icon: FaFile,
    permissions: ['files.update'],
  },
  {
    label: 'Localizations',
    action: '/admin/localizations',
    icon: FaLanguage,
    permissions: ['localizations.update'],
  },
  {
    label: 'Site banners',
    action: '/admin/site-banners',
    icon: FaBullhorn,
    permissions: ['settings.update'],
  },
  {
    label: 'Ads',
    action: '/admin/ads',
    icon: FaAd,
    permissions: ['settings.update'],
  },
  {
    label: 'Support',
    action: '/admin/support',
    icon: FaLifeRing,
    permissions: ['support.tickets'],
  },
  {
    label: 'System',
    action: '/admin/system/smoke',
    icon: FaServer,
    permissions: ['settings.update'],
  },
  {
    label: 'Logs',
    action: '/admin/logs',
    icon: FaLogs,
    permissions: ['logs.view'],
  },
];

// Изменено: 2026-01-09 - Создан статичный конфиг для admin-navbar
// Описание: Меню навбара админки теперь статичное, не берется из БД
// По умолчанию пустое, но можно добавить пункты если нужно
export const adminNavbarItems: AdminMenuItem[] = [
  // Пока пусто, можно добавить пункты меню для навбара админки если нужно
];
